import { Navigate } from 'react-router';
import { useAuth } from '@/contexts/AuthContext';
import { PLAN_ORDER } from '@gatheredhq/types';
import type { PlanTier } from '@gatheredhq/types';

interface PlanGateProps {
  /** Minimum plan required to access this route */
  minPlan: PlanTier;
  children: React.ReactNode;
}

/**
 * Route-level plan guard. Redirects to /billing if the user's plan
 * is below the required minimum — cannot be bypassed by direct URL access.
 */
export default function PlanGate({ minPlan, children }: PlanGateProps) {
  const { user, loading } = useAuth();

  if (loading) return null;

  const userTier = PLAN_ORDER[user?.plan as PlanTier] ?? 0;
  const requiredTier = PLAN_ORDER[minPlan] ?? 1;

  if (userTier < requiredTier) {
    return <Navigate to="/billing" replace />;
  }

  return <>{children}</>;
}
